import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ToastState {
  isVisible: boolean;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  timeout?: number;
  timestamp?: EpochTimeStamp
}

const initialState: ToastState = {
  isVisible: false,
  type: 'info',
  message: '',
  timeout: 7000, // Default 5 seconds timeout
  timestamp: 0
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<Omit<ToastState, 'isVisible'> & { timeout?: number }>) => {
      state.isVisible = true;
      state.type = action.payload.type;
      state.message = action.payload.message;
      // Use custom timeout if provided, otherwise use default
      state.timeout = action.payload.timeout !== undefined ? action.payload.timeout : 7000;
      state.timestamp = Date.now()
    },
    hideToast: (state) => {
      state.isVisible = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;